import { render, staticRenderFns } from "./wx-bind.vue?vue&type=template&id=48d85d76&scoped=true&"
import script from "./wx-bind.vue?vue&type=script&lang=js&"
export * from "./wx-bind.vue?vue&type=script&lang=js&"
import style0 from "./wx-bind.vue?vue&type=style&index=0&id=48d85d76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d85d76",
  null
  
)

export default component.exports